import AbstractChannel from './AbstractChannel'

export default class ParkMobile extends AbstractChannel {

  name = 'park_mobile'
  title = 'ParkMobile'
  titleShort = 'ParkMobile'
  color = '#bcbd22'

}
